export default __webpack_public_path__ + "static/media/img-devices.4c27d10e.jpg";